import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { HeartIcon } from 'lucide-react';
export function Proof() {
  return <section className="py-16 px-6 bg-white" data-id="element-127">
      <div className="max-w-3xl mx-auto" data-id="element-128">
        <FadeIn data-id="element-129">
          <div className="bg-brand-cream border-2 border-brand-gold/20 p-8 md:p-12 rounded-3xl shadow-soft text-center" data-id="element-130">
            <HeartIcon className="w-12 h-12 text-brand-terracotta mx-auto mb-6" data-id="element-131" />
            <h3 className="text-2xl md:text-3xl font-serif font-bold mb-6 leading-tight" data-id="element-132">
              Resultados que puedes sentir
            </h3>
            <p className="text-xl mb-4" data-id="element-133">
              En solo <strong data-id="element-134">7 días</strong>, notarás que tus rodillas
              "truenan" menos al subir escaleras.
            </p>
            <p className="text-xl" data-id="element-135">
              Para el <strong data-id="element-136">día 14</strong>, esa opresión en las manos al
              despertar habrá disminuido tanto que podrás abrir frascos y coser
              con la agilidad de hace diez años.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}